import {defineStore} from 'pinia';
import {ModuleBudgetSourceDvc} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';

/**
 * Store thông tin về các nguồn kinh phí mapping với kho bạc điện tử'
 */
import BudgetSourceDvcApi from '@/apis/di/budgetSourceDvcApi';
const budgetSourceDvcStore = new BaseDictionaryStore(BudgetSourceDvcApi);
export const useBudgetSourceDvcStore = defineStore(ModuleBudgetSourceDvc, {
  state: () => ({
    ...budgetSourceDvcStore.state,
    _config: {
      key: 'budget_source_dvc_id',
      code: 'budget_source_dvc_code',
      name: 'budget_source_dvc_name',
      table: 'di_budget_source_dvc',
      moduleName: 'Bảng lưu trữ thông tin về các nguồn kinh phí mapping với kho bạc điện tử',
      defaultSort: 'type, budget_source_dvc_group_type, budget_source_dvc_id_mapping',
    },
    moduleName: 'diBudgetSourceDvc',
  }),
  actions: {
    ...budgetSourceDvcStore.action,
  },
  getters: {
    ...budgetSourceDvcStore.getters,
  },
});
